import { EducationInformation } from './EducationInformation';

export class ResidencyProgramDetail extends EducationInformation {
}
